import { useSendbird } from '@sendbird/uikit-react';
import { useCallback, useMemo } from 'react';

const useSendbirdApi = () => {
  const {
    state: { stores },
  } = useSendbird();

  const sendbirdChatSdk = useMemo(() => stores?.sdkStore?.sdk, [stores?.sdkStore?.sdk]);

  const connect = useCallback(
    async (userId: string) => {
      return await sendbirdChatSdk?.connect?.(userId);
    },
    [sendbirdChatSdk],
  );

  const disconnect = useCallback(async () => {
    return await sendbirdChatSdk?.disconnect?.();
  }, [sendbirdChatSdk]);

  return {
    sendbirdChat: sendbirdChatSdk,
    connect,
    disconnect,
  };
};

export default useSendbirdApi;
